
import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { GxUtilsService } from 'app/shared/services/gx-utils.service';
import { Subject } from 'rxjs';
import { ActionUpdaterService, ApiError } from 'app/shared/services/action-updater.service';
import { FormGroup, ValidationErrors } from '@angular/forms';

@Injectable()
export class ErrorService {
    constructor(private gxUtilsService: GxUtilsService,
        private actionUpdaterService: ActionUpdaterService) {

    }
    private broadcastError(error: ApiError) {
        this.actionUpdaterService.announceError(error);
    }
    private broadcastErrors(errors: ApiError[]) {
        this.actionUpdaterService.announceErrors(errors);
    }
    dispatchError = (error, scopedFormName) => {
        if (!!scopedFormName) {
            this.dispatchFormErrorEvent(error.message, []);
        } else {
            this.dispatchErrorEvent(error);
        }
    }
    reset = () => {
        this.actionUpdaterService.announceClear(null);
    }
    dispatchAjaxError = (statusCode, errorData) => {
        let ajaxErrors = !!errorData.Message ? [errorData.Message] : [];
        if (!!errorData.Errors && !!errorData.Errors.length) {
            const errors = new Set();
            errorData.Errors.forEach(element => {
                errors.add(element.Value);
            });
            ajaxErrors = Array.from(errors);
        }
        const error = new ApiError();
        error.summary = errorData.ErrorSummary || errorData.Title || errorData.ExceptionMessage;
        error.details = ajaxErrors;
        this.broadcastError(error);
    }

    dispatchFormError = (formController: FormGroup) => {
        this.dispatchFormErrorWithMessage(formController, 'Please complete required fields!');
    }

    dispatchFormErrorWithMessage = (formController: FormGroup, error) => { // TODO check all method
        const formErrors = [];
        let invalidCard = false;
        // Check for invalid credit card to ensure duplicate card validation messages do not appear.
        for (const key of Object.keys(formController.controls)) {
            const controlErrors: ValidationErrors = formController.get(key).errors;
            if (controlErrors != null) {
                for (const keyError of Object.keys(controlErrors)) {
                    if (keyError === 'ccNumber') {
                        invalidCard = true;
                        break;
                    }
                }
            }
            if (invalidCard) {
                break;
            }
        }
        for (const key of Object.keys(formController.controls)) {
            const controlErrors: ValidationErrors = formController.get(key).errors;
            if (controlErrors != null) {
                for (const err of Object.keys(controlErrors)) {
                    // NOTE: If using NESTED FORMS, one of the $error[i] items is actually your nested form.
                    // You will need to figure out if the item is a 'FormController' instead of 'NgModelController'
                    // then loop through all it's own $errors as well.
                    let propertyName = this.gxUtilsService.camelCaseToHuman(key);
                    // Customising messages for certain error types and situations. Gotta be a better way than this but running out of time.
                    if (propertyName === 'Passenger Picker Form') {
                        formErrors.push('Please select the type of special assistance required');
                    } else if (propertyName === 'Terms And Conditions') {
                        formErrors.push('You must accept the Terms and Conditions before proceeding');
                    } else if (key === 'ccNumber') {
                        formErrors.push('\'Card Number\' is invalid');
                    } else if (key === 'ccNumberType') {
                        if (!invalidCard) {
                            formErrors.push('\'Card Number\' type is not accepted (We only accept Visa and Mastercard)');
                        }
                    } else {
                        if (propertyName === 'Booking Pin') { propertyName = 'PIN'; }
                        if (propertyName === 'Cvv') { propertyName = 'CVV'; }
                        // cater for a number of cases where instead of specific error type that is not friendly to users,
                        // we want to just display invalid.
                        const myArray = ['parse', 'ccExpMonth', 'ccExpYear'];
                        if (myArray.indexOf(key) !== -1) {
                            formErrors.push(`'${propertyName}' is invalid`);
                        } else if (key === 'minlength') {
                            formErrors.push(`'${propertyName}' is too short`);
                        } else {
                            formErrors.push(`'${propertyName}' is ${err}`);
                        }
                    }
                }
            }
        }
        this.dispatchFormErrorEvent(error, formErrors);
    }

    dispatchFormErrorMessage = (error) => {
        this.dispatchFormErrorEvent(error, []);
    }
    private dispatchFormErrorEvent = (message: string, formErrors: string[]) => {
        const error = new ApiError();
        error.summary = message;
        if (!!formErrors && !!formErrors.length) {
            error.details = formErrors;
        }
        this.broadcastError(error);
    }
    private dispatchErrorEvent = (error) => {
        this.broadcastError(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/error.service.ts